// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__2HeL9","title":"ClientReferral_title__3z9c4","itemText":"ClientReferral_itemText__r3EkJ"};